import _slicedToArray from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useEffect, useState } from 'react';
import { EventBus } from '@vtblife/event-bus';
import get from 'lodash/get';
export var useAuthorizedUser = function useAuthorizedUser() {
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    user = _useState2[0],
    setUser = _useState2[1];
  useEffect(function () {
    var eventBus = EventBus.getInstance();
    var subscription = eventBus === null || eventBus === void 0 ? void 0 : eventBus.subscribe('app:contextChanged', function (event) {
      var newUser = get(event, 'data.authInfo.user');
      setUser(newUser);
    }, {
      eventCategory: 'behavior'
    });
    return function () {
      return subscription.unsubscribe();
    };
  }, []);
  return user;
};